import React, { Component, Fragment } from "react";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";

import { routesContext } from "../../../shared/routes/routes-context";
import PromoBanner from "../../../shared/components/banners/PromoBanner";

export default class Stats extends Component {
  static contextType = routesContext;
  render() {
    const editCombinedScoresPath = window.location.pathname.includes(
      "edit-combined-score"
    );
    const viewAvgScorePerHolePath = window.location.pathname.includes(
      "view-avg-score-per-hole"
    );
    const shouldNotRenderButtons =
      window.location.pathname.includes("total-round-summary") ||
      window.location.pathname.includes("hbh-round-summary");
    return (
      <Fragment>
        <PromoBanner />
        <div className="container">
          <section className="stats_section" role="heading" aria-level="1">
            {!shouldNotRenderButtons && (
              <ul className="tabs light">
                <li>
                  <NavLink
                    to={this.context.statsScoreHistory.path}
                    className={viewAvgScorePerHolePath ? "is-active" : ""}
                    activeClassName="is-active"
                  >
                    Score History
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={this.context.statsCharts.path}
                    className={editCombinedScoresPath ? "is-active" : ""}
                    activeClassName="is-active"
                  >
                    Stats
                  </NavLink>
                </li>
              </ul>
            )}
            <Switch>
              <Redirect
                exact
                from={this.context.stats.path}
                to={this.context.statsScoreHistory.path}
              />
              <Route {...this.context.statsScoreHistory} />
              <Route {...this.context.statsCharts} />
              <Route {...this.context.statsEditCombinedScore} />
              <Route {...this.context.viewAvgScorePerHole} />
              <Route {...this.context.roundSummaryTotal} />
              <Route {...this.context.roundSummaryHbh} />
            </Switch>
          </section>
        </div>
      </Fragment>
    );
  }
}
